export var EPIC_BEGIN = '@@redux-most/EPIC_BEGIN';
export var EPIC_END = '@@redux-most/EPIC_END';
export var STATE_STREAM_SYMBOL = Symbol('@@redux-most/STATE_STREAM');


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-most/es/constants.js
// module id = 146
// module chunks = 0